<template>
  <div class="category-container d-none d-lg-block" v-if="!extended">
    <b-container class="d-flex justify-content-between align-items-center">
      <div class="category d-flex align-items-center">
        <router-link
          :key="category.category"
          :to="`/gallery/${category.category}/`"
          v-for="category in primaryCategories"
        >
          {{ category.name }}
        </router-link>
      </div>
      <a href @click.prevent="extended = !extended"
        ><font-awesome-icon icon="bars"
      /></a>
    </b-container>
  </div>
  <div class="category-container expanded d-none d-lg-block" v-else>
    <b-container class="d-flex justify-content-between align-items-start py-4">
      <div class="category d-flex flex-wrap align-items-center">
        <router-link
          :key="category.category"
          :to="`/gallery/${category.category}/`"
          v-for="category in categories"
          @click.native="extended = false"
        >
          {{ category.name }}
        </router-link>
      </div>
      <a href @click.prevent="extended = !extended" style="margin-top: -25px"
        ><font-awesome-icon icon="times" size="lg"
      /></a>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      extended: false,
      primaryCategories: [],
      categories: window.categories
    };
  },
  beforeMount() {
    this.primaryCategories = window.primaryCategories
      .map(category => {
        return window.categories.find(c => {
          return c.name.toLowerCase() == category.toLowerCase();
        });
      })
      .filter(category => category);
  }
};
</script>

<style lang="scss" scoped>
.category-container {
  position: fixed;
  top: 60px;
  width: 100%;
  z-index: 1000;
  background-color: #b10101;
  height: 28px;
  font-family: Josefin Sans, sans-serif;

  a {
    padding: 6px 19px 3px 19px;
    color: white;
    white-space: nowrap;

    &.router-link-active {
      background-color: #eaeaea;
    }
  }

  .category {
    overflow: hidden;

    a {
      text-transform: uppercase;
    }
  }

  &.expanded {
    height: auto;

    .category a {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      -webkit-box-flex: 0;
      -ms-flex: 0 0 16.66667%;
      flex: 0 0 16.66667%;
      max-width: 0 0 16.66667%;
    }
  }
}
</style>
